<template>
  <a-modal
    title="变更记录"
    width="80%"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    :footer="null"
  >
    <ls-api-table
      ref="changeDataTable"
      :columns="columns"
      :pagination="false"
      :tableProps="tableProps"
      :data-source="tableData"
      rowKey="id"
      :scroll="{ y: 400 }"
    >
    </ls-api-table>
  </a-modal>
</template>

<script>
import { getPoolQueryBySourceRowId } from '@/api/scp/month-plan-pool/month-plan-pool'
// import { generateLsTableResData } from '@/utils/util.js';
// import { CHANGE_TYPE_ENUM, INITIATION_TYPE_ENUM } from '../common'
export default {
  props: {},
  data () {
    return {
      visible: false,
      tableData: [],
      tableProps: {
        requestApi: null
      },
      columns: [
        { title: '发起类型', dataIndex: 'initiationTypeName' },
        { title: '变更类型', dataIndex: 'changeTypeName' },
        { title: '原数量', dataIndex: 'originalQuantity' },
        { title: '变更数量', dataIndex: 'changeQuantity' },
        { title: '原定计划周期', dataIndex: 'originalPlanCycle' },
        { title: '变更计划周期', dataIndex: 'changePlanCycle' },
        { title: '责任方', dataIndex: 'responsiblePartyName' },
        { title: '执行日期', dataIndex: 'pricingDate' },
        { title: '原价格', dataIndex: 'originalPrice' },
        { title: '变更价格', dataIndex: 'changePrice' },
        { title: '原触发档位', dataIndex: 'originalTriggerLevel' },
        { title: '实际触发档位', dataIndex: 'actualTriggerLevel' },
        { title: '变更原因', dataIndex: 'changeReason', width: 160 },
        { title: '关联变更单号', dataIndex: 'changeNo' }
      ],
      queryParams: {
        id: ""
      }
    }
  },
  created () {},
  methods: {
    show (val) {
      this.queryParams.id = val.id
      this.getData()
      this.visible = true
      // this.$nextTick(() => {
      //   this.onSearch()
      // })
    },
    // 获取数据
    getData() {
      this.tableData = []
      getPoolQueryBySourceRowId({ id: this.queryParams.id }).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.tableData = res.data
          this.$nextTick(() => {
            this.$refs.changeDataTable.getData()
          })
        }
      })
    },
    // 表单搜索
    // onSearch () {
    //   this.$refs.dataTable.searchParams = this.queryParams;
    //   this.$refs.dataTable.getData();
    // },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 表单重置
    reset () {
      this.queryParams = {
        id: ""
      }
      this.$refs.changeDataTable.myDataSource = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body {
  height: 450px;
  overflow-y: scroll;
}
</style>
